import Pusher from 'pusher-js';

let client;

export default function PusherClient() {
  if (client) { return client; }

  return new Pusher(process.env.REACT_APP_PUSHER_KEY, {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    useTLS: true,
    authEndpoint: '/auth/pusher',
  });
}
